import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.css']
})
export class ApplicationComponent implements OnInit {
  @Input() formStep: FormGroup;
  @Input() stiftelser: any;

  dropDownOptions1 = {
    //BARN OCH UNGA SAMT SJUKA OCH GAMLA, Ändamål och krav från stiftelsens stadgar:
    'Oscar och Maria Rappes stiftelse':
      'Stiftelsen har till ändamål att stödja barns och ungdoms fostran och utbildning eller att ge hjälp till behövande sjuka och gamla.',
    'Stiftelsen Jan Lundahls minnesfond':
      'Stiftelsen har till ändamål att främja barns eller ungdoms vård och fostran eller utbildning eller att främja vård av behövande äldre, sjuka eller funktionshindrade.',
    'Anna Tryggs Stiftelse':
      'Stiftelsen har till ändamål att främja barns eller ungdoms vård och fostran eller utbildning eller att främja vård av behövande äldre, sjuka eller funktionshindrade.',
    'Stiftelsen unga hjälpares fond för barn och ungdom':
      'Stöd kan lämnas åt kyrklig verksamhet, som syftar till hjälp åt barn och ungdom, som är i behov av speciell hjälp och skydd.',

    // DÖVA ELLER HÖRSELSKADADE
    'Stiftelsen Folke Anderssons fond':
      'Stiftelsen har till ändamål att främja dövas semestervistelse.',
    'Stiftelsen för dövas vård och bästa':
      'Stiftelsen har till ändamål att stödja behövande döva eller främja vård av döva.',
    'Stiftelsen Anna-Britta och Bengt Attefelts fond':
      'Stiftelsens ändamål är att i Sverige främja medicinsk forsning, lämna bistånd till behövande sjuka och handikappade människor, enskilda såväl som grupper. Bidraget kan ha formen av ekonomiska bidrag till vård, rekreation, tekniska hjälpmedel etc. Obs! År 2023 - Bidrag till Svenska kyrkans verksamhet att användas i fondens syfte och anda. Endast stift, pastorat och församlingar kan söka i år.',

    // ÄLDRE
    'Stiftelsen Amelie Högfeldts minnesfond':
      'Stiftelsen har till ändamål att för ensamma äldre kvinnor - helst ur den s.k. pauvres honteux-klassen - anordna ett hem, där dessa på ålderdomen kunna mot en jämförelsevis ringa eller i vissa fall ingen ersättning erhålla en lugn, behaglig och dem passande fristad. Skulle hinder möta för hemmets upprättande, äger förvaltaren bestämma om tillgångarnas användning för ett närliggande ändamål.',

    // MEDICINSKA STUDIER

    'Femte Dövstumsdistriktets stiftelse':
      'Stiftelsen har till ändamål att lämna bidrag för boendekostnader till dövas boende inom Örebro och Värmlands län.',

    // KYRKLIGT ARBETE
    'J.E. Frykbergs stiftelse':
      'Stiftelsen har till ändamål att stödja det frivilliga arbetet inom svenska kyrkan samt att stödja ungdomsarbetet i alla dess former - det frivilliga kyrkliga bildningsarbetet, den religiösa upplysningsverksamheten m.m.',
    'Stiftelsen Makarna Axel och Elisabet Welins missionsfond':
      'Stipendium kan sökas av svenska missionssällskap med evangelisk trosbekännelse, som bedriver sjukhusvård eller klinisk verksamhet utom Sverige.',
    'Stiftelsen SKM:s fond för missionsforskning':
      'Stiftelsen har till ändamål att främja missionsforskning',
    'Anna Trygg stiftelse':
      'Stiftelsen har till ändamål att främja barns eller ungdoms vård och fostran eller utbildning eller att främja vård av behövande ålderstigna, sjuka eller lytta.'
  };

  dropDownOptions2 = [
    { id: 0, value: 2020 },
    { id: 1, value: 2019 },
    { id: 2, value: 2018 },
    { id: 3, value: 2017 },
    { id: 4, value: 2016 },
    { id: 5, value: 2021 },
    { id: 6, value: 2022 },
    //{ id: 7, value: 2023 }
  ];

  constructor() {}

  ngOnInit(): void {}
}
